import { isEqual } from 'lodash'
import { parse, classname } from 'tailwindcss-class-parser'

const HTML_BREAKPOINT = 'lg'

const createCommand = ({ editor, chain, value, property, utilities, device, toggle, selectedValue, unselectedValue }) => {
  if (toggle) {
    value = getToggleValue({ name: property, selectedValue, unselectedValue, editor, device, utilities })
  }

  const { classes = [] } = editor.getAttributes('tailwindBlock')
  const newClasses = updateClasses({ property, value, classes, utilities, device })
  return chain().focus().setMark('tailwindBlock', { classes: newClasses }).run()
}

const updateClasses = ({ property, value, classes, utilities, device }) => {
  const utilitiesVariants = utilities.map(item => ({ value: item }))
  const newEntry = { property, value, variants: utilitiesVariants, device }
  const withoutDuplicated = removeDuplicatedClasses(classes, newEntry)
  return addDeviceBreakpoint(value ? [...withoutDuplicated, newEntry] : withoutDuplicated)
}

const removeDuplicatedClasses = (classes, newEntry) => classes.filter(item => {
  if (item.property === newEntry.property && item.device === newEntry.device) {
    return JSON.stringify(item.variants.filter(item => item.value !== HTML_BREAKPOINT)) === JSON.stringify(newEntry.variants) ? false : true
  }
  return true
})

const addDeviceBreakpoint = classes => classes = classes.map(item => {
  const addDeviceBreakpoint = classes.find(classItem => classItem.property === item.property && classItem.value !== item.value && JSON.stringify(classItem.variants) === JSON.stringify(item.variants) && item.device === 'desktop' && classItem.device === 'mobile')
  addDeviceBreakpoint && !item.variants.find(value => value.value === HTML_BREAKPOINT) && item.variants.push({ value: HTML_BREAKPOINT })
  return item
})

const addDevice = classes => classes = classes.map(item => {
  const isMobile = classes.find(classItem => classItem.property === item.property && classItem.value !== item.value && classItem.variants.find(item => item.value === HTML_BREAKPOINT))
  item.device = isMobile ? 'mobile' : 'desktop'
  return item
})

const getTailwindValue = ({ name, value, editor, device, utilities, extensionName = 'tailwindBlock' }) => {
  const getValue = deviceToUse => classes.find(item => item.property === name && isEqual(item.variants.filter(item => item.value !== 'lg'), variants) && item.device === deviceToUse)
  const validValue = valueToUse => !value ? valueToUse : value === valueToUse?.value ? valueToUse : undefined

  const classes = editor.getAttributes(extensionName)?.classes || []
  const variants = utilities.map(item => ({ value: item }))

  const desktopValue = getValue('desktop')
  const mobileValue = getValue('mobile')
  const valueToUse = device === 'mobile' ? mobileValue || desktopValue : desktopValue || mobileValue
  return validValue(valueToUse)
}

const createCommandForNode = ({ editor, chain, value, property, utilities, device }) => {
  const { classes = [] } = editor.getAttributes('paragraph')
  const newClasses = updateClasses({ property, value, classes, utilities, device })
  return chain().focus().updateAttributes('paragraph', { classes: newClasses }).run()
}

const getToggleValue = ({ name, selectedValue, unselectedValue, editor, device, utilities }) => getTailwindValue({ name, value: selectedValue, editor, device, utilities }) ? unselectedValue : selectedValue

const parseClassesIntoAttributes = classList => {
  const classes = []
  for (const classItem of classList) {
    const parsed = parse(classItem)
    classes.push({ property: parsed.property, value: parsed.value, variants: parsed.variants.map(({ value }) => ({ value })) })
  }

  return addDevice(classes)
}

const parseAttributesIntoClasses = classes => {
  const classesParsed = []
  for (const className of classes) {
    const parsed = classname(className)
    classesParsed.push(parsed)
  }

  const classesParsedString = [...new Set(classesParsed)].join(' ')
  return classesParsedString ? { class: classesParsedString } : {}
}

export {
  HTML_BREAKPOINT,
  createCommand,
  updateClasses,
  removeDuplicatedClasses,
  addDeviceBreakpoint,
  addDevice,
  getTailwindValue,
  createCommandForNode,
  parseClassesIntoAttributes,
  parseAttributesIntoClasses,
}
